<template>

    <el-dialog
            :visible.sync="dialogvisible"
            width="60%"
            center @close="closeDialog;$emit('update:dialogvisible', false)">

        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="margin-top-10">
            <div class="hastaKabulBaslikSerit animated fadeInUp">
                <div class="hastaKabulBaslik">
                    <h1>{{hastaisimSoyisim}} Tedavi Detayı</h1>
                </div>
            </div>
            <el-row class="ozel-row animated fadeInUp">

                <el-col :lg="12" :md="12" :sm="24" :xs="24">
                    <div class="formBilgileri">
                        <div class="formBilgiBaslik">Dr. Bilgileri</div>
                        <div class="mobil-baslik">Dr. Bilgileri</div>
                        <div class="formElemanlari">
                            <div class="doktor-bilgi">
                                <div class="input-effect">
                                    <div class="formBilgi">Adı Soyadı:</div>
                                    <div class="effect-7 yazdir-bilgisi">{{hekimAdi}}</div>
                                </div>
                                <div class="input-effect">
                                    <div class="formBilgi">Telefon:</div>
                                    <div class="effect-7 yazdir-bilgisi">{{hekimTel}}</div>
                                </div>
                                <div class="input-effect">
                                    <div class="formBilgi">E-Mail:</div>
                                    <div class="effect-7 yazdir-bilgisi">{{hekimMail}}</div>
                                </div>
                                <div class="input-effect">
                                    <div class="formBilgi">Klinik:</div>
                                    <div class="effect-7 yazdir-bilgisi">{{hekimKlinik}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :lg="12" :md="12" :sm="24" :xs="24">
                    <div id="hastaBilgileri" class="formBilgileri ozel-sagayasla">
                        <div class="mobil-baslik">Hasta Bilgileri</div>
                        <div class="formElemanlari">
                            <div class="doktor-bilgi">
                                <div class="input-effect">
                                    <div class="formBilgi">{{hastaBilgiAdi}}:</div>
                                    <div class="effect-7 yazdir-bilgisi">{{hastaBilgi}}</div>
                                </div>
                                <div class="input-effect">
                                    <div class="formBilgi">Adı Soyadı:</div>
                                    <div class="effect-7 yazdir-bilgisi">{{hastaisimSoyisim}}</div>
                                </div>
                                <div class="input-effect">
                                    <div class="formBilgi">Yaş / Cinsiyet:</div>
                                    <div class="effect-7 yazdir-bilgisi">{{hastaYas}} / {{hastaCinsiyet}}</div>
                                </div>
                                <div class="input-effect">
                                    <div class="formBilgi">İl:</div>
                                    <div class="effect-7 yazdir-bilgisi">{{hastaSehir}}</div>
                                </div>
                                <div class="input-effect">
                                    <div class="formBilgi">Telefon:</div>
                                    <div class="effect-7 yazdir-bilgisi">{{hastaTel}}</div>
                                </div>
                                <div v-if="hastaMail!=='' || hastaMail!==null" class="input-effect">
                                    <div class="formBilgi">E-Mail:</div>
                                    <div class="effect-7 yazdir-bilgisi">{{hastaMail}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="formBilgiBaslik sagTaraf">Hasta Bilgileri</div>
                    </div>
                </el-col>
            </el-row>
            <el-row class="animated fadeInUp" style="display: flex; justify-content: center">
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <div class="grupBilgisi margin-top-20">
                        <p>Ortopedi Uygulama</p>
                    </div>
                    <div class="disOpsiyonlari">
                        <div class="opsiyonDiv">
                            <div>Tarih:</div>
                            <div>{{tarih}}</div>
                        </div>
                        <div class="opsiyonDiv">
                            <div>Ürün Adı:</div>
                            <div>{{urunAdi}}</div>
                        </div>
                        <div class="opsiyonDiv">
                            <div>Referans No:</div>
                            <div>{{referansNo}}</div>
                        </div>
                        <div class="opsiyonDiv">
                            <div>Barkod No:</div>
                            <div>{{barkodNo}}</div>
                        </div>
                        <div class="opsiyonDiv">
                            <div>SUT Kodu:</div>
                            <div>{{sutKodu}}</div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-col>

        <span slot="footer" class="dialog-footer">
    <el-button style="visibility: hidden">Cancel</el-button>
  </span>
    </el-dialog>
</template>

<script>
    import hastaOrtopediService from "../WSProvider/HastaOrtopediService";
    import notification from '../notification'
    import EventBus from '@/components/event-bus'
    import urunOrtopediService from "../WSProvider/UrunOrtopediService";

    export default {

        name: "OrtopediHastaDetay",
        props: ['userdataOrtopediHastaDetay', 'dialogvisible'],
        mounted() {
            this.hastaDetay();
        },
        data() {
            return {
                hekimAdi: '',
                hekimTel: '',
                hekimMail: '',
                hastaSehir: '',
                hastaisimSoyisim: '',
                hastaCinsiyet: '',
                hastaYas: '',
                hastaMail: '',
                hastaBilgi: '',
                hekimKlinik: '',
                hastaTel: '',
                tarih: '',
                urunAdi: '',
                hastaBilgiAdi: '',
                urunId: '',
                referansNo: '',
                sutKodu: '',
                barkodNo: '',

                dialogvisible: false,
            }
        },
        methods: {
            hastaDetay() {
                hastaOrtopediService.hastaOrtopediDetay(this.userdataOrtopediHastaDetay).then((response) => {
                    if (response.status === 200) {
                        this.hastaSehir = response.data.il;
                        this.hastaisimSoyisim = response.data.adSoyad;
                        this.hastaTel = response.data.telefon;
                        this.hastaCinsiyet = response.data.cinsiyet;
                        this.hastaYas = response.data.yas;
                        this.hastaMail = response.data.eposta;
                        this.hastaBilgiAdi = response.data.bilgiAdi;
                        this.hastaBilgi = response.data.bilgi;
                        this.tarih = response.data.detay[0].tarih;
                        this.urunId = response.data.detay[0].islemDetay[0].oUrunId;
                        this.getUrunDetay(this.urunId);
                        this.hekimAdi = response.data.hekim;
                        this.hekimTel = response.data.hekimTelefon;
                        this.hekimMail = response.data.hekimEPosta;
                        this.hekimKlinik = response.data.klinikAdi;

                        console.log(response.data)
                    } else {
                        notification.Status(response.status, this)
                    }
                })
                this.dialogvisible = true
            },

            getUrunDetay(gelenId) {
                urunOrtopediService.urunOrtopediDetay(gelenId).then((response) => {
                    if (response.status === 200) {
                        this.referansNo = response.data.referansNo;
                        this.sutKodu = response.data.sutKodu;
                        this.urunAdi = response.data.urunAdi;
                        this.barkodNo = response.data.barkodNo;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },

            closeDialog() {
                this.dialogvisible = false;
            },
            closeEventDialog() {
                this.dialogvisible = false
            },
        },
        components: {
            EventBus,
        }
    }
</script>

<style scoped>
    .hastaKabulBaslik {
        display: flex;
        justify-content: center;
        align-items: center;
        display: -webkit-box;
        display: -ms-flexbox;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
    }

    .hastaKabulBaslik h1 {
        background: #161c3c;
        color: #fff;
        font-weight: 700;
        padding: 8px 20px;
        position: relative;
    }

    .hastaKabulFormu {
        position: relative;
        z-index: 10;
    }

    .formBilgileri {
        display: flex;
    }

    .ozel-sagayasla {
        float: right;
    }

    .formBilgiBaslik {
        writing-mode: tb-rl;
        transform: rotate(180deg);
        float: left;
        text-align: center;
        background: #161c3c;
        color: #fff;
        padding: 12px 2px;
        text-transform: uppercase;
        font-weight: 600;
        position: relative;
        min-height: 190px;
    }

    .mobil-baslik {
        display: none;
        text-align: center;
        background: #161c3c;
        padding: 5px 2px;
        text-transform: uppercase;
        font-weight: 600;
        width: 100%;
        color: #fff;
    }

    .formElemanlari {
        padding: 0 20px !important;
    }

    .input-effect {
        position: relative;
        display: flex;
        align-items: flex-start;
    }

    .input-effect .formBilgi {
        height: 100%;
        padding: 10px 10px 0;
        font-size: 14px;
        font-weight: 600;
        flex-shrink: 0;
        min-width: 90px;
    }


    .yazdir-bilgisi {
        font-size: 14px;
        padding: 5px;
    }

    .effect-7, .effect-8, .effect-9 {
        border: 1px solid transparent;
        padding: 10px 10px 0;
        transition: .4s;
        width: 100%;
    }

    .formBilgiBaslik.sagTaraf {
        transform: none;
    }

    .formBilgiBaslik:before {
        content: "";
        position: absolute;
        top: 50%;
        right: 27px;
        transform: translate(0, -50%);
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 10px 10px 0;
        border-color: transparent #161c3c transparent transparent;
    }

    .grupBilgisi {
        background: linear-gradient(90deg, rgba(22, 28, 60, 0) 5%, rgba(22, 28, 60, 0.5) 25%, rgba(22, 28, 60, 1) 40%, rgba(22, 28, 60, 1) 60%, rgba(22, 28, 60, 0.5) 75%, rgba(22, 28, 60, 0) 95%);
        font-size: 14px;
        font-weight: 500;
        padding: 8px 6px;
        text-align: center;
    }

    .grupBilgisi p {
        margin: 0;
        color: #fff;
    }

    .disOpsiyonlari {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        width: 100%;
        padding-top: 10px;
        page-break-inside: avoid;
        justify-content: start;
    }

    .yazdirFormSayfa .disNumarasi-yazdir {
        border-bottom: 1px solid #eee;
    }


    .randevular .opsiyonDiv {
        padding: 6px 5px;
        width: 18%;
        margin: 4px 0;
        text-align: center;
        font-size: 14px;
        position: relative;
        /*border-bottom: 1px solid #ddd;*/
    }

    .opsiyonDiv {
        padding: 6px 5px;
        width: calc(20% - 10px);
        margin: 4px 0;
        text-align: center;
        font-size: 14px;
        position: relative;
        /*border-bottom: 1px solid #ddd;*/
    }


    .doktor-bilgi {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }


    .opsiyonDiv:before {
        content: "";
        position: absolute;
        width: 2px;
        height: 100%;
        right: 0;
        top: 0;
        background: #3cbcb4;
        background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }


    .opsiyonDiv:nth-child(1):after {
        content: "";
        position: absolute;
        width: 2px;
        height: 100%;
        left: 0;
        top: 0;
        background: #3cbcb4;
        background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }

    .disler-arasi-cizgi {
        height: 2px;
        width: 95%;
        position: relative;
        left: 50%;
        transform: translateX(calc(-50% + -27px));
        margin: 8px 0;
        background: linear-gradient(transparent, #3cbcb4, transparent);
    }

    .disNumarasi-yazdir div:first-child {
        color: #3cbcb4;
        text-transform: uppercase;
    }

    .opsiyonDiv div:first-child {
        font-weight: 600;
        color: #444;
        margin-bottom: 5px;
    }

    .disNumarasi-yazdir div:last-child {
        font-weight: 700;
    }

    .disNumarasi-yazdir div:last-child span {
        padding: 3px 7px;
        border: 1px solid #00bcb4;
        color: #0a716b;
        display: inline-block;
    }


    .opsiyonDiv div:first-child {
        font-weight: 600;
        color: #444;
        margin-bottom: 5px;
    }

    .ozel-row {
        display: flex;
        justify-content: center;
    }

    @media only screen and (max-width: 480px) {
        .opsiyonDiv:nth-child(1):after,
        .opsiyonDiv:nth-child(3):after,
        .opsiyonDiv:nth-child(5):after,
        .opsiyonDiv:nth-child(7):after {
            content: "";
            position: absolute;
            width: 2px;
            height: 100%;
            left: 0;
            top: 0;
            background: #3cbcb4;
            background: -webkit-gradient(linear, left top, left bottom, from(transparent), color-stop(#3cbcb4), to(transparent));
            background: linear-gradient(transparent, #3cbcb4, transparent);
        }

        .opsiyonDiv {
            width: 45%;
        }

        .ozel-row {
            display: block;
        }

        .input-effect .formBilgi {
            padding: 5px;
            min-width: 60px;
        }

        .formBilgiBaslik {
            display: none;
        }

        .formBilgiBaslik:before {
            display: none;
        }

        .ozel-sagayasla {
            float: none;
        }

        .formElemanlari {
            padding: 0 !important;
        }

        .mobil-baslik {
            display: block;
        }

        .formBilgileri {
            display: block;
        }

        .doktor-bilgi {
            position: static;
            transform: none;
        }
    }

    @media only screen and (max-width: 768px) {
        .opsiyonDiv {
            width: 45%;
        }

        .ozel-row {
            display: block;
        }

        .input-effect .formBilgi {
            padding: 5px;
            min-width: 86px;
        }

        .formBilgiBaslik {
            display: none;
        }

        .formBilgiBaslik:before {
            display: none;
        }

        .ozel-sagayasla {
            float: none;
        }

        .formElemanlari {
            padding: 0 !important;
        }

        .mobil-baslik {
            display: block;
        }

        .formBilgileri {
            display: block;
        }

        .doktor-bilgi {
            position: static;
            transform: none;
        }
    }
</style>
